export default "__VITE_ASSET__BwJj0ano__"